/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useMemo, useState } from "react";
import CommonModule from "../CommonModule";
import { DepartColDefs } from "../columnDefs";
import { LoadingPage } from "../../../../common/LoadingPage";
import { Box, Button, Dialog, DialogActions, DialogContent, Divider, Grid, Link, styled, Switch, Tooltip, Typography } from "@mui/material";
import { apiRequest } from "../../../../common/common";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import FilterPanel from "./FilterPanel";
import { ArrowBack, DeleteOutline, EditOutlined } from "@mui/icons-material";
import CreateModule from "../CreateModule";
import { CurrencyJSON, DepartmentType, getProjectSize } from "../../../../common/const";
import moment from "moment";
import ColumnHeader from "../../Catalog/columnHeader";
import { useSelector } from "react-redux";
import ColumnPanel from "../../../../common/ColumnPanel";
import * as XLSX from 'xlsx';

const DemoTypo = styled(Typography)(({ theme }) => ({
    fontSize: 14
}));

const DemoTypo1 = styled(Typography)(({ theme }) => ({
    fontSize: 14,
    fontWeight: 'bold'
}));

const FixedBox = styled(Box)(({ theme }) => ({
    width: '110px'
}));

const DepartmentModule = ({
    projectId,
    projectData,
    level,
    setActiveTab,
    setDepartment,
}) => {
    const { user, roles } = useSelector((state) => state.users);
    const isUser = roles.find((a) => a.id === user?.role_id);
    const [rowsPerPage, setRowPerPage] = useState(localStorage.getItem('departmentPageSize') || 10);
    const [searchingText, setSearchText] = useState(null || localStorage.getItem('search'));
    const [gridApi, setGridApi] = useState(null);
    const [dataLoading, setDataLoading] = useState(false);
    const [selectedData, setSelectedData] = useState([]);
    const [notes, setNotes] = useState(null);
    const [deleteOpen, setDeleteOpen] = useState(false);
    const [open, setOpen] = useState(false);
    const [departmentData, setDepartmentData] = useState(null);
    const [isChecked, setIsChecked] = useState(false);
    const [indeterminate, setIndeterminate] = useState(false);
    const [returnedData, setReturnedData] = useState([]);
    const [activePage, setActivePage] = useState(1);
    const [countData, setCountData] = useState({});
    const [departmentColumn, setDepartmentColumn] = useState(DepartColDefs);
    const [settingData, setSettingData] = useState([]);

    const onGridReady = useCallback((params) => {
        if (params?.api) {
            const { api, searchingText, filters } = params;
            if (filters) {
                localStorage.setItem('depfilters', JSON.stringify(filters));
            }
            const filter = localStorage.getItem('depfilters') ? JSON.parse(localStorage.getItem('depfilters')) : filters;
            setGridApi(api);
            setDataLoading(true);
            const dataSource = {
                rowCount: null,
                getRows: async (params) => {
                    const sortModel = params?.sortModel[0];
                    const sortBy = {
                        column: sortModel?.colId === 'cost_centre' ? 'cost_centre_name' : sortModel?.colId || '',
                        order: sortModel?.sort || '',
                    };
                    setActivePage(Math.floor((params.startRow / rowsPerPage) + 1));
                    if (projectId) {
                        const url = [
                            `/department?projectId=${projectId}`,
                            level?.level_id ? `&levelIds=${level?.level_id}` : '',
                            `pageNo=${Math.floor((params.startRow / rowsPerPage) + 1)}`,
                            `pageSize=${rowsPerPage}`,
                            filter?.departmentType?.length > 0 ? `type=${filter?.departmentType}` : '',
                            filter?.building?.length > 0 ? `buildingIds=${filter?.building}` : '',
                            filter?.level?.length > 0 ? `levelIds=${filter?.level}` : '',
                            filter?.costCentre?.length > 0 ? `costCentreIds=${filter?.costCentre}` : '',
                            filter?.areaPhase?.length > 0 ? `phaseIds=${filter?.areaPhase}` : '',
                            filter?.isDeleted === 'yes' || filter?.isDeleted === 'no' ? `isDeleted=${filter?.isDeleted === 'yes' ? true : ''}` : `isDeleted=${level?.is_deleted ? true : ''}`,
                            filter?.isNotes === 'yes' || filter?.isNotes === 'no' ? `isNotes=${filter?.isNotes}` : '',
                            sortBy?.column ? `sortBy=${sortBy.column}` : '',
                            sortBy?.order ? `sortOrder=${sortBy.order}` : '',
                            searchingText || localStorage.getItem('search') ? `searchText=${encodeURIComponent(searchingText || localStorage.getItem('search'))}` : ''
                        ].filter(Boolean).join('&');
                        try {
                            const response = await apiRequest('get', `${url}`);
                            const { data, total_count, total_department_count, total_area, total_cost } = response.data;
                            let lastRow = -1;
                            if (data?.length <= total_count) {
                                lastRow = total_count;
                            }
                            setReturnedData(data);
                            setSelectedData([]);
                            setIsChecked(false);
                            setCountData({
                                total_area,
                                total_quantity: total_department_count,
                                total_cost
                            });
                            params.successCallback(data, lastRow);
                            setDataLoading(false);
                        } catch (error) {
                            setDataLoading(false);
                            showNotification(error?.response?.data.error || error.message, 'error');
                        }
                    }
                },
            };
            api.setGridOption("datasource", dataSource);
            setTimeout(() => {
                const node = api.getRenderedNodes();
                if (!node?.[0]?.displayed) {
                    api.showNoRowsOverlay();
                }
            }, 5000);
        }
    }, [rowsPerPage, projectId, level?.level_id]);

    useEffect(() => {
        let isMounted = true;
        if (isMounted) {
            onGridReady({
                api: gridApi,
            });
        }
        return () => {
            isMounted = false;
        };
    }, [rowsPerPage, projectId, level?.level_id]);

    useEffect(() => {
        if (departmentColumn?.length > 0 && gridApi) {
            const columnState = gridApi?.getColumnState()?.map(state => {
                const columnConfig = departmentColumn.find((c) => c.colId === state.colId || c.field === state.colId);
                if (columnConfig) {
                    if (columnConfig.pinned !== state.pinned) {
                        state.pinned = columnConfig.pinned ? columnConfig.pinned : null;
                    }
                }

                return state;
            });
            gridApi?.applyColumnState({ state: columnState });
            gridApi?.refreshHeader();
        }
    }, [departmentColumn]);


    const getData = async () => {
        try {
            setDataLoading(true)
            const response = await apiRequest('get', `/user-view?userId=${user?.user_id}&type=project-department&pageNo=1&pageSize=50`);
            const { data } = response.data;
            if (data?.length > 0) {
                if (data?.find((a) => a.is_pinned === true)?.columns) {
                    setDepartmentColumn([...departmentColumn.slice(0, 3), ...data?.find((a) => a.is_pinned === true)?.columns]);
                }
                setSettingData(data);
            } else {
                setSettingData([]);
            }
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    useEffect(() => {
        if (user?.user_id) {
            getData();
        }
    }, [user?.user_id])


    const handleExportExcel = async () => {
        try {
            setDataLoading(true);
            const url = [
                `/department?projectId=${projectId}`,
                level?.level_id ? `levelIds=${level.level_id}` : '',
                `pageNo=1`, `pageSize=10000`,
            ].filter(Boolean).join('&');
            const response = await apiRequest('get', url);
            const { data } = response.data;
            const currencySymbol = CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol ?? '';
            const exportRows = (data || []).map((row) => ({
                'Dept No': row.department_no ?? '--',
                'Department Name': row.department_name ?? '--',
                'Type': DepartmentType.find((a) => a.value === row.type)?.name ?? '--',
                'Building': row.building?.building_name ?? '--',
                'Level': row.level?.level_name ?? '--',
                'Phase': row.phase?.phase_name ?? '--',
                'Cost Centre': row.cost_centre?.cost_centre_name ?? '--',
                'Phase Date': row.phase_date ? moment(row.phase_date).format('DD-MM-YYYY') : '--',
                'Status': row.is_deleted === false ? 'Active' : 'InActive',
                'Active Rooms': row.active_room_count ?? 0,
                'Inactive Rooms': row.inactive_room_count ?? 0,
                'Combined Rooms': row.all_room_count ?? 0,
                'Total Area': row.total_area ? getProjectSize(projectData?.default_project_units, row.total_area) : '--',
                'Sub Total': `${currencySymbol} ${Intl.NumberFormat('en-IN').format(row.sub_total || 0)}`,
                'Total Cost': `${currencySymbol} ${Intl.NumberFormat('en-IN').format(row.department_total_amount || 0)}`,
                'Notes': row.notes ?? '--',
            }));
            const ws = XLSX.utils.json_to_sheet(exportRows);
            ws['!cols'] = Object.keys(exportRows[0] || {}).map((key) => ({
                wch: Math.max(key.length, ...exportRows.map((r) => String(r[key] ?? '').length)) + 2,
            }));
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, 'Departments');
            XLSX.writeFile(wb, `Departments_${projectId}.xlsx`);
        } catch (error) {
            showNotification(error?.response?.data?.error || error.message, 'error');
        } finally {
            setDataLoading(false);
        }
    };

    const toolPanel = useMemo(() => [
        {
            id: 'custom1',
            labelDefault: 'Columns',
            iconKey: "columns",
            toolPanel: ColumnPanel,
            width: 450,
            toolPanelParams: {
                columns: departmentColumn?.slice(3, 20),
                setColumns: (column) => {
                    setDepartmentColumn([...departmentColumn.slice(0, 3), ...column]);
                },
                settingData,
                fetchData: () => {
                    if (user?.user_id) {
                        getData();
                    }
                },
                type: "project-department",
                defaultVisibleColumns: DepartColDefs?.slice(3, 20),
                columnOrder: departmentColumn?.slice(3, 20)
            }
        },
        {
            id: 'custom2',
            iconKey: "filter",
            labelDefault: 'Filters',
            toolPanel: FilterPanel,
            width: 300,
            toolPanelParams: {
                applyFilter: (filters) => {
                    setRowPerPage(localStorage.getItem('departmentPageSize') || 10)
                    onGridReady({
                        api: gridApi,
                        filters
                    });
                },
                projectId
            }
        }
    ], [gridApi, settingData, departmentColumn]);

    const onSelectChanged = (value) => {
        if (gridApi) {
            if (value === 1) {
                const selectedNodes = gridApi.getSelectedNodes();
                gridApi.forEachNode((node) => {
                    selectedNodes.push(node);
                    node.setSelected(true);
                });
                const uniqueNodesSet = new Set(selectedNodes);
                const uniqueNodesArray = Array.from(uniqueNodesSet);
                const data = uniqueNodesArray.map((node) => node.data);
                setSelectedData(data);
            } else if (value === 2) {
                const selectedNodes = gridApi.getSelectedNodes();
                selectedNodes.forEach((node) => node.setSelected(false));
            }
        }
    };

    const removeAllColumn = () => {
        if (gridApi) {
            setSelectedData([]);
            setIsChecked(false);
            setIndeterminate(false);
            const selectedNodes = gridApi.getSelectedNodes();
            selectedNodes.forEach((node) => node.setSelected(false));
        }
    };

    const updatedColumns = useMemo(() => {
        let column = departmentColumn;
        if (column.length > 0) {
            return column?.map((col) => {
                switch (col.field) {
                    case '':
                        return {
                            ...col,
                            hide: isUser?.code === 'orgGuestUser',
                            headerComponent: ColumnHeader,
                            headerComponentParams: {
                                onSelectChanged,
                                removeAllColumn,
                                isChecked,
                                setIsChecked,
                                indeterminate,
                                setIndeterminate,
                            },
                        };
                    case 'action':
                        return {
                            ...col,
                            hide: isUser?.code === 'orgGuestUser',
                            cellRenderer: (params) => params?.data && (
                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                    {!params?.data?.is_deleted && (
                                        <Tooltip title="Edit Department">
                                            <EditOutlined
                                                color="primary"
                                                style={{ cursor: 'pointer', color: selectedData?.length === 1 && selectedData?.find((a) => a.department_id === params?.data?.department_id) ? '' : 'gray' }}
                                                onClick={() => {
                                                    if (selectedData?.length === 1 && selectedData?.find((a) => a.department_id === params?.data?.department_id)) {
                                                        setOpen(true);
                                                        setDepartmentData(params?.data);
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    )}
                                    <Tooltip title={params?.data?.is_deleted === false ? 'Active' : 'InActive'}>
                                        <Switch
                                            size="small"
                                            disabled={!selectedData?.find((a) => a.department_id === params?.data?.department_id)}
                                            checked={params?.data?.is_deleted === false}
                                            onChange={async (e) => {
                                                setDataLoading(true);
                                                try {
                                                    const response = await apiRequest('patch', `/department/set-delete-status/${selectedData?.map((a) => a.department_id)?.toString()}`, {
                                                        isDeleted: e.target.checked === true ? false : true
                                                    });
                                                    if (response?.data) {
                                                        onGridReady({
                                                            api: gridApi
                                                        })
                                                        setDataLoading(false);
                                                        showNotification(response?.data?.message, 'success');
                                                    }
                                                } catch (error) {
                                                    setDataLoading(false);
                                                    showNotification(error?.response?.data.error || error.message, 'error');
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                    <Tooltip title="Permanent Delete">
                                        <DeleteOutline
                                            color="secondary"
                                            style={{ cursor: 'pointer', color: selectedData?.find((a) => a.department_id === params?.data?.department_id) ? '' : 'gray' }}
                                            onClick={() => {
                                                if (selectedData?.find((a) => a.department_id === params?.data?.department_id)) {
                                                    setDeleteOpen(true);
                                                }
                                            }}
                                        />
                                    </Tooltip>
                                </Box>
                            ),
                        }
                    case 'department_name':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 220,
                            cellRenderer: (params) => {
                                if (params?.data && !params?.data.is_deleted) {
                                    return (
                                        <Link
                                            style={{ textDecoration: 'none', cursor: 'pointer' }}
                                            onClick={() => {
                                                setActiveTab('Rooms');
                                                setDepartment(params?.data);
                                            }}
                                        >

                                            {params?.data?.department_name || '--'}
                                        </Link>
                                    )
                                } else {
                                    return (
                                        <span
                                            style={{ textDecoration: 'none', cursor: 'pointer', color: 'red' }}
                                            onClick={() => {
                                                setActiveTab('Rooms');
                                                setDepartment(params?.data);
                                            }}
                                        >
                                            {params?.data?.department_name || '--'
                                            }</span>
                                    )
                                }
                            },
                        }
                    case 'department_no':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 105,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.department_no ? (
                                <span>{params?.data?.department_no}</span>
                            ) : '--'
                        }
                    case 'status':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {!params?.data?.is_deleted ? 'Active' : 'InActive'}
                                </>
                            ),
                        }
                    case 'building':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.building?.building_name || '--'}
                                </>
                            ),
                        }
                    case 'level':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.level?.level_name || '--'}
                                </>
                            ),
                        }
                    case 'phase_name':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.phase?.phase_name || '--'}
                                </>
                            ),
                        }
                    case 'cost_centre':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.cost_centre?.cost_centre_name || '--'}
                                </>
                            ),
                        }
                    case 'phase_date':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.phase_date ? moment(params?.data?.phase_date).format('DD-MM-YYYY') : '--'}
                                </>
                            ),
                        }
                    case 'total_cost':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.department_total_amount || 0)}`}
                                </>
                            ),
                        }
                    case 'subtotal':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {`${CurrencyJSON.find((a) => a.value === projectData?.currency)?.symbol} ${Intl.NumberFormat('en-IN').format(params?.data?.sub_total || 0)}`}
                                </>
                            ),
                        }
                    case 'total_combind_rooms':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 130,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.all_room_count || 0}
                                </>
                            ),
                        }
                    case 'total_area':
                        return {
                            ...col,
                            sortable: false,
                            flex: 1,
                            minWidth: 200,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.total_area !== null && params?.data?.total_area ? getProjectSize(projectData?.default_project_units, (params?.data?.total_area)) : '--'}
                                </>
                            ),
                        }
                    case 'type':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 150,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {DepartmentType.find((a) => a.value === params?.data?.type)?.name || '--'}
                                </>
                            ),
                        }
                    case 'total_rooms':
                        return {
                            ...col,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.active_room_count || 0}
                                </>
                            ),
                        }
                    case 'total_inactive_rooms':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 120,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data && (
                                <>
                                    {params?.data?.inactive_room_count || 0}
                                </>
                            ),
                        }
                    case 'notes':
                        return {
                            ...col,
                            flex: 1,
                            minWidth: 110,
                            cellStyle: (params) => {
                                if (params?.data?.is_deleted) {
                                    return {
                                        color: 'red'
                                    }
                                }
                                return {
                                    background: params.node.rowIndex % 2 === 0 ? 'white' : '#d8e2e5',
                                };
                            },
                            cellRenderer: (params) => params?.data?.notes ? (
                                <Link
                                    style={{ textDecoration: 'none', cursor: 'pointer' }}
                                    onClick={() => {
                                        setNotes(params?.data.notes);
                                    }}
                                >
                                    View Notes
                                </Link>
                            ) : '--',
                        }
                    default:
                        return col;
                }
            });
        }
        return column;
    }, [departmentColumn, selectedData, indeterminate, isChecked]);

    return (
        <>
            {dataLoading && (<LoadingPage isLoading={dataLoading} />)}
            <Grid container>
                <Dialog open={deleteOpen} fullWidth maxWidth="xs">
                    <DialogContent>Are you sure you want to permanently delete this one? It cannot be recovered.</DialogContent>
                    <DialogActions>
                        <Button size="small" variant="contained" color="secondary"
                            onClick={() => {
                                setSelectedData([]);
                                setDeleteOpen(false);
                            }}
                        >
                            No
                        </Button>
                        <Button
                            size="small"
                            variant="contained"
                            color="primary"
                            onClick={async () => {
                                try {
                                    setDataLoading(true);
                                    let response = await apiRequest('delete', `/department/${selectedData?.map((a) => a.department_id)?.toString()}`);
                                    if (response?.data) {
                                        setDataLoading(false);
                                        showNotification(response?.data?.message, 'success');
                                        setSelectedData([]);
                                        setDeleteOpen(false);
                                        onGridReady({
                                            api: gridApi
                                        });
                                    }
                                } catch (error) {
                                    setDataLoading(false);
                                    showNotification(error?.response?.data.error || error.message, 'error');
                                }
                            }}
                        >
                            Yes
                        </Button>
                    </DialogActions>
                </Dialog>
                {open && (
                    <CreateModule
                        open={open}
                        setOpen={setOpen}
                        getData={() => onGridReady({
                            api: gridApi
                        })}
                        innerLabel="Department"
                        projectId={projectId}
                        initialData={departmentData}
                    />
                )}
                <Grid item xs={12} sm={12} md={level || notes !== null ? 10 : 12} style={{ padding: '0px 8px 0px 8px' }}>
                    <CommonModule
                        label={"Departments"}
                        innerLabel="Department"
                        columnDefs={updatedColumns}
                        onGridReady={onGridReady}
                        rowsPerPage={rowsPerPage}
                        setRowPerPage={setRowPerPage}
                        searchingText={searchingText}
                        setSearchText={setSearchText}
                        toolPanel={toolPanel}
                        projectId={projectId}
                        gridApi={gridApi}
                        level={level}
                        onSelectionChanged={() => {
                            if (gridApi) {
                                const selectedNodes = gridApi.getSelectedNodes();
                                if (selectedNodes?.length < returnedData?.length * activePage) {
                                    setIsChecked(false);
                                    if (selectedNodes?.length === 0) {
                                        setIndeterminate(false);
                                    } else {
                                        setIndeterminate(true);
                                    }
                                } else {
                                    setIsChecked(true);
                                    setIndeterminate(false);
                                }
                                setSelectedData(selectedNodes.map((node) => node.data));
                            }
                        }}
                        projectData={projectData}
                        selectionType="multiple"
                        selectedData={selectedData}
                        countData={countData}
                        setSelectedData={setSelectedData}
                        setColumns={setDepartmentColumn}
                        onExport={handleExportExcel}
                    />
                </Grid>
                {notes !== null && (
                    <Grid item xs={12} sm={12} md={2} style={{ borderLeft: '1px solid lightgray' }}>
                        <Box mt={1} mb={1} ml={1}>
                            <Box style={{ display: 'flex', alignItems: 'center', gap: 5 }} mb={1}>
                                <ArrowBack style={{ cursor: 'pointer', fontSize: 20 }} onClick={() => {
                                    setNotes(null);
                                }} />
                                <DemoTypo1 variant="body2">Notes:</DemoTypo1>
                            </Box>
                            <Divider />
                            <Box style={{ height: '57vh', overflow: 'auto' }} mt={1}>
                                <DemoTypo variant="body2">{notes}</DemoTypo>
                            </Box>
                        </Box>
                    </Grid>
                )}
                {(level !== null && notes === null) && (
                    <Grid item xs={12} sm={12} md={2} style={{ borderLeft: '1px solid lightgray' }}>
                        <Box mt={1} mb={1} ml={1}>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Level Name:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{level?.level_name}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Level ID:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{level?.level_no || '--'}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Building Name:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{level?.building?.building_name}</DemoTypo>
                            </Box>
                            <Box mt={1} style={{ display: 'flex', gap: 5 }}>
                                <FixedBox>
                                    <DemoTypo1 variant="body2">Level Notes:</DemoTypo1>
                                </FixedBox>
                                <DemoTypo variant="body2">{level?.notes || '--'}</DemoTypo>
                            </Box>
                        </Box>
                    </Grid>
                )}
            </Grid>
        </>
    )
}

export default DepartmentModule;